__turbopack_context__.v({
  "addToCart": "ProductDetailsModalSkeleton-module-scss-module__r3i7aG__addToCart",
  "container": "ProductDetailsModalSkeleton-module-scss-module__r3i7aG__container",
  "description": "ProductDetailsModalSkeleton-module-scss-module__r3i7aG__description",
  "footerContainer": "ProductDetailsModalSkeleton-module-scss-module__r3i7aG__footerContainer",
  "metaContainer": "ProductDetailsModalSkeleton-module-scss-module__r3i7aG__metaContainer",
  "modificationsContainer": "ProductDetailsModalSkeleton-module-scss-module__r3i7aG__modificationsContainer",
  "priceLabel": "ProductDetailsModalSkeleton-module-scss-module__r3i7aG__priceLabel",
  "productImage": "ProductDetailsModalSkeleton-module-scss-module__r3i7aG__productImage",
  "productName": "ProductDetailsModalSkeleton-module-scss-module__r3i7aG__productName",
  "quantityModifier": "ProductDetailsModalSkeleton-module-scss-module__r3i7aG__quantityModifier",
  "variantContainer": "ProductDetailsModalSkeleton-module-scss-module__r3i7aG__variantContainer",
  "variantItem": "ProductDetailsModalSkeleton-module-scss-module__r3i7aG__variantItem",
  "variantName": "ProductDetailsModalSkeleton-module-scss-module__r3i7aG__variantName",
  "variantNameContainer": "ProductDetailsModalSkeleton-module-scss-module__r3i7aG__variantNameContainer",
  "variantPrice": "ProductDetailsModalSkeleton-module-scss-module__r3i7aG__variantPrice",
  "variantSelection": "ProductDetailsModalSkeleton-module-scss-module__r3i7aG__variantSelection",
  "variantTitle": "ProductDetailsModalSkeleton-module-scss-module__r3i7aG__variantTitle",
});
